"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Weights = exports.FontFamilies = void 0;
// GENERATED FILE, PLEASE DO NOT EDIT
var FontFamilies = {
  SansSerif: 'TTNorms',
  Serif: 'SourceSerifPro'
};
exports.FontFamilies = FontFamilies;
var Weights = {
  100: 'TTNorms-Thin',
  200: 'TTNorms-ExtraLight',
  300: 'TTNorms-Light',
  400: 'TTNorms-Regular',
  500: 'TTNorms-Medium',
  700: 'TTNorms-Bold',
  800: 'TTNorms-ExtraBold',
  900: 'TTNorms-Black'
};
exports.Weights = Weights;